module.exports = __webpack_public_path__ + "media/images/binder_logo-d09b3144fad540a59628249faa6181f5.png";